import { useEffect, useState } from "react";

const NOMES = [
  "--series-1",
  "--series-2",
  "--grid",
  "--axis",
  "--text-muted",
  "--surface",
  // Qual dos dois temas está em vigor. Vem do CSS em vez de uma media query
  // repetida em JS: assim há um só sítio que decide o tema, e o interruptor
  // manual (`data-theme`) é respeitado sem código extra.
  "--modo",
] as const;

export type Tokens = Record<(typeof NOMES)[number], string>;

function ler(): Tokens {
  const estilo = getComputedStyle(document.documentElement);
  const saida = {} as Tokens;
  for (const nome of NOMES) saida[nome] = estilo.getPropertyValue(nome).trim();
  return saida;
}

/**
 * Lê os tokens de cor do CSS e volta a lê-los quando o tema muda.
 *
 * O Recharts precisa de cores como valor (usa-as nos pontos, no cursor e nos
 * `<path>`), e um `stroke="var(--series-1)"` posto como atributo de SVG não
 * resolve. Em vez de fixar hex no código — que partiria o modo escuro — lê-se
 * a variável que o CSS já define para o tema em vigor.
 */
export function useTokens(): Tokens {
  const [tokens, setTokens] = useState<Tokens>(ler);

  useEffect(() => {
    const consulta = window.matchMedia("(prefers-color-scheme: dark)");
    const aoMudar = (): void => setTokens(ler());
    consulta.addEventListener("change", aoMudar);

    // Um interruptor de tema futuro mexe no atributo, não na media query.
    const observador = new MutationObserver(aoMudar);
    observador.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => {
      consulta.removeEventListener("change", aoMudar);
      observador.disconnect();
    };
  }, []);

  return tokens;
}
